<div class="wrapper d-flex flex-direction-column">
  <div class="d-flex justify-content-between">
    <div class="t-footnote-medium">{{ caption }}</div>
    <div class="t-footnote-medium">{{ fileName }}</div>
  </div>

  <div
    (click)="dropInput.click()"
    class="upload-button cursor-pointer d-flex justify-content-center align-items-center"
    matRipple
  >
    <input
      hidden
      type="file"
      #dropInput
      name="file"
      [accept]="config.availableFileTypes || defaultFileTypes"
      (change)="addFile($event.target.files)"
      (click)="dropInput.value = null"
    />

    <span class="t-footnote-semibold">Upload photo</span>
  </div>
</div>
